import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Card, Button, LoadingSpinner } from '../components/Layout';
import api from '../services/api';

const STATUS_LABEL: Record<string, string> = {
  new: 'New', assigned: 'Assigned', in_progress: 'In progress',
  waiting: 'Waiting', resolved: 'Resolved', closed: 'Closed',
};
const STATUS_CLASS: Record<string, string> = {
  new: 'bg-blue-900/50 text-blue-200 border-blue-700',
  assigned: 'bg-indigo-900/50 text-indigo-200 border-indigo-700',
  in_progress: 'bg-amber-900/50 text-amber-200 border-amber-700',
  waiting: 'bg-gray-800 text-gray-300 border-gray-600',
  resolved: 'bg-green-900/50 text-green-200 border-green-700',
  closed: 'bg-gray-800 text-gray-400 border-gray-700',
};
const fmt = (d: any) => (d ? new Date(d).toLocaleDateString() : '');

// The employee's own requests only. Status + the resolution note management
// leaves — never anyone else's requests, never the internal category or flags.
export function MyRequestsPage() {
  const [loading, setLoading] = useState(true);
  const [rows, setRows] = useState<any[]>([]);

  useEffect(() => {
    api.getMySupportRequests().then(r => setRows(r || [])).finally(() => setLoading(false));
    // Opening this page clears the "responded to" flasher.
    api.markSupportRequestsSeen();
  }, []);

  if (loading) return <div className="flex justify-center p-8"><LoadingSpinner /></div>;

  return (
    <div className="space-y-6">
      <Card>
        <div className="flex justify-between items-center mb-4">
          <h1 className="text-2xl font-bold text-white">My Requests</h1>
          <Link to="/report-problem"><Button>Report a problem</Button></Link>
        </div>
        {rows.length === 0 ? (
          <p className="text-gray-400 py-8 text-center">You haven't reported anything yet.</p>
        ) : (
          <div className="space-y-3">
            {rows.map(r => (
              <div key={r.id} className="rounded-lg border border-gray-700 bg-gray-900 p-4">
                <div className="flex items-start justify-between gap-3">
                  <div className="min-w-0">
                    <div className="text-xs text-gray-500 mb-1">{r.requestNumber} · {fmt(r.createdAt)}</div>
                    <div className="text-white whitespace-pre-wrap">{r.description}</div>
                  </div>
                  <span className={`shrink-0 px-2 py-0.5 rounded-full text-xs font-medium border ${STATUS_CLASS[r.status] || STATUS_CLASS.new}`}>
                    {STATUS_LABEL[r.status] || r.status}
                  </span>
                </div>
                {r.resolutionNote && (
                  <div className="mt-3 rounded bg-green-900/20 border border-green-800 px-3 py-2 text-sm">
                    <span className="text-green-300 font-medium">Resolution: </span>
                    <span className="text-green-100">{r.resolutionNote}</span>
                  </div>
                )}
              </div>
            ))}
          </div>
        )}
      </Card>
    </div>
  );
}

export default MyRequestsPage;
